import { render } from "./ProveedoresList.vue?vue&type=template&id=a5e16dbc&scoped=true"
import script from "./ProveedoresList.vue?vue&type=script&lang=js"
export * from "./ProveedoresList.vue?vue&type=script&lang=js"

import "./ProveedoresList.vue?vue&type=style&index=0&id=a5e16dbc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e16dbc"]])

export default __exports__